import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../../Footers/Footer/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import QuestionsAnswers from './../../Widget/QuestionsAnswers/index.vue'
import ReputationData from './../../Widget/ReputationData/index.vue'
import { Auth, Api, Toast } from './../../../../services'

export default {
  name: 'ProductDetails',
  props: [],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswers,
    ReputationData,
  },
  data() {
    return {
      product: {
        _id: '',
        name: '',
        description: '',
        specs: '',
        price: '',
        type: '',
        details: {
          number: '',
          weight: '',
          shipping: '',
          manufacture: '',
          asin: '',
        },
        images: [''],
        available: 0,
        accept: true,
      },
      reviews: [],
      comment: [],
      itemCount: 1,
      validationMessage: null,
      contactMeIsDone: false,
      curentImage: '',
      userIsLogin: false,
      isOwner: false
    }
  },
  methods: {
    minusItem() {
      if (this.itemCount > 1) {
        this.itemCount--
      }
    },
    plusItem() {
      if (this.itemCount < this.product.available) {
        this.itemCount++
      }
    },
    async contactMe() {
      try {
        this.$refs.progress.show()

        await Api.contactMe(this.$route.params.id)

        this.contactMeIsDone = true

        Toast.success({
          toast: this.$toast,
          title: 'Congratulations!',
          message: 'Your application will be processed.',
        })
      } catch (error) {
        console.error(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    try {
      this.userIsLogin = Auth.isLogin()

      var response = await Api.getProductById(this.$route.params.id)

      if (response.data && !response.data.error) {
        this.product = response.data.results.product
        this.reviews = response.data.results.opinion
        this.comment = response.data.results.comment
        this.curentImage = this.product.images[0]
        const userInfo = Auth.getUserData()
        this.isOwner = (userInfo.id === this.product.user[0]['_id']) ? true : false
      } else {
        this.validationMessage = 'Something went wrong.'
        console.error('Something went wrong.')
      }
    } catch (error) {
      console.error(error)
      Toast.error({
        toast: this.$toast,
        title: 'Error',
        message: error.message,
      })
    } finally {
      this.$refs.progress.hide()
    }
  },
  mounted() {
    $('.modal').modal()
    $('select').material_select()
  },
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Services/Details/ServicesDetails.component.js